import {
  DISMISS_GTI_NOTIFICATION,
  HIDE_GTI_BEGIN_MODAL,
  RECEIVE_GTI_TOKEN,
  SHOW_GTI_BEGIN_MODAL,
  SHOW_GTI_INTERGRATION,
} from './actions';

export const initialState = {
  modalIsVisible: false,
  gtiStatus: null,
  token: '',
  isFetching: false,
  showNotification: true,
};

export const reducer = (state = initialState, action) => {
  let { type, payload } = action;
  switch (type) {
    case SHOW_GTI_BEGIN_MODAL: {
      return {
        ...state,
        modalIsVisible: true,
      };
    }
    case HIDE_GTI_BEGIN_MODAL: {
      return {
        ...state,
        modalIsVisible: false,
      };
    }
    case SHOW_GTI_INTERGRATION: {
      return {
        ...state,
        gtiStatus: payload,
        isFetching: true,
      };
    }
    case RECEIVE_GTI_TOKEN: {
      return {
        ...state,
        token: payload,
        isFetching: false,
      };
    }
    case DISMISS_GTI_NOTIFICATION: {
      return {
        ...state,
        showNotification: false,
      };
    }
    default:
      return state;
  }
};
